import { render } from "./MyforinerUpload.vue?vue&type=template&id=f331039e"
import script from "./MyforinerUpload.vue?vue&type=script&lang=js"
export * from "./MyforinerUpload.vue?vue&type=script&lang=js"

import "./MyforinerUpload.vue?vue&type=style&index=0&id=f331039e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__